module.exports = __webpack_public_path__ + "static/img/coperation_area.289cc40.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/coperation_area.gif
// module id = b/PE
// module chunks = 1